export default "__VITE_ASSET__DmfIabF8__"